module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"files":"file","files_plural":"files"},"et":{"files":"files","files_plural":"files"},"ru":{"files_0":"файл","files_1":"файла","files_2":"файлов"}}')
  delete Component.options._Ctor
}
